<template>
  <div>
    <div class="air__utils__heading">
      <h3>Perfiles</h3>
    </div>
    <div class="row">
      <div class="col-lg-12">

        <TableProfiles :data="Profiles" :clusters="Clusters" v-on:update="fetchProfiles()"/>
      </div>
    </div>
  </div>
</template>

<script>
import TableProfiles from './widgets/TableProfiles'

// import profilesRepository from './../../repository/profilesRepository'
import { RepositoryFactory } from '@/repository/RepositoryFactory'

const AlgoliaRepository = RepositoryFactory.get('algolia')
const ProfilesRepository = RepositoryFactory.get('profiles')

export default {
  components: {
    TableProfiles,
  },
  created() {
    // this.verifedAuthPoderIO()

  },
  mounted() {
    this.fetchProfiles()
    this.getClusters()

    // console.log(document.cookie);
  },
  data () {
    return {
      Clusters: [],
      Profiles: [],
    }
  },

  methods: {
    async getClusters() {
      console.log('THIS.CLUSTERS: ${this.Clusters}')
      try {
        const { data } = await ProfilesRepository.getClusters()

        console.log('getClusters', data)

        this.Clusters = data.data
      } catch (error) {


        // console.log(error)

        if (error.response.status == 401) {
          this.generateTokenEpica()
        } else {
          this.$notification['warning']({
            message: error.code,
            description: error.message,
          })
        }
      }
    },

    async generateTokenEpica() {
      try {
        this.$notification['info']({
          message: 'Token Vencido',
          description: 'Generando nuevo token',
        })

        const {data} = await ProfilesRepository.auth()
        



        if ( data.data.message != '') {

          const token =  data.data.message;
          
          localStorage.setItem('token', token);

          this.$notification['success']({
            message: 'Token Generado con exito!',
            description: 'Lista de clusters actualizado',
          })

           this.getClusters();
        }

        // this.Clusters = data.data
      } catch (error) {
        console.log(error)
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

    async fetchProfiles() {
      try {
        const { data } = await ProfilesRepository.getProfiles()

        console.log(data.data)
        this.Profiles = data.data
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },
    callback (key) {
      console.log(key)
    },

    async verifedAuthPoderIO() {
      try {
        const authPoderio = await profilesRepository.auth()
        console.log(authPoderio)
        // this.Profiles = data.items
      } catch (error) {
        this.$notification['warning']({
          message: error.code,
          description: error.message,
        })
      }
    },

  },
}
</script>
